<div
  class="bg-white rounded-lg p-10 min-w-sm lg:w-[506px] max-w-[506px] w-full">
  <div class="flex flex-col gap-12">
    <ng-content />
  </div>
</div>
